import DefaultLayout from '../../layout/DefautlLayout';
import Header from '../../components/header/Header';
import styled from './treatment.module.css';
import treatments from '../../models/treatments';

const TreatmentsPage = () => {
	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<div
								className={`section mcb-section bg-cover`}
								style={{
									paddingTop: '0px',
									paddingBottom: '0px',
									backgroundImage: 'url(/assets/images/banners/treatment-xl-2.png)',
									backgroundRepeat: 'no-repeat',
									backgroundPosition: 'right bottom',
								}}>
								<div className="section_wrapper mcb-section-inner">
									<div
										className="wrap mcb-wrap one valign-top clearfix"
										style={{
											padding: '30% 0 10%',
										}}>
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-second column_column">
												<div className={`clearfix ${styled.bannerTextWidth}`}>
													<h2>Treatments</h2>
													<hr
														className="no_line"
														style={{
															margin: '0 auto 15px',
														}}
													/>
													<p>
														Following a consultation, here are some of the treatments we offer at Sitara Clinic, from Anti-Wrinkle
														treatment for women and men, to dermal and lip fillers, PRP and Skinboosters, we will definitely have
														atreatment to suit you and help you glow.
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className={styled.pusherDiv}></div>

							<div className="section center bg-theme hrmargin_b_60" style={{ paddingTop: '30px', paddingBottom: '15px' }}>
								<div className="section_wrapper clearfix">
									<div className="items_group clearfix">
										<div className="column_attr">
											<h3 className="text-light" style={{ letterSpacing: '3px' }}>
												Anti-wrinkle injections
											</h3>
										</div>
									</div>
								</div>
							</div>

							<div
								className="section mcb-section"
								id="image"
								style={{
									paddingBottom: '70px',
								}}>
								<div className="section" id="image flv_sections_16">
									<div className="items_group clearfix">
										{treatments.map((treatment, index) => (
											<>
												<div className={`section_wrapper hrmargin_b_30${index % 2 !== 0 ? ' d-md-flex row-reverse' : ''}`} key={index}>
													<div className="column one-third column_image">
														<div className="image_frame scale-with-grid has_border aligncenter">
															<div className="image_wrapper">
																<div className="mask"></div>
																<img
																	className="scale-with-grid"
																	width="100%"
																	height="auto"
																	src={treatment.image}
																	alt={treatment.title}
																/>
															</div>
														</div>
													</div>

													<div className="column two-third column_column">
														<div className="column_attr">
															<h3>{treatment.title}</h3>

															<p className={index === 0 ? styled.hiddenDesc : ''}>{treatment.description}</p>

															<div
																className={`button_align ${index === 0 ? 'align_left' : index % 2 === 0 ? 'align_right' : 'align-left'}`}>
																<a className="button button_size_2 button_theme button_js" href={treatment.link}>
																	<span className="button_label">PRICES & RESULTS</span>
																</a>
															</div>
														</div>
													</div>
												</div>
												<div className="column one column_divider">
													<hr className="no_line" />
												</div>
											</>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default TreatmentsPage;
